import React from 'react';
import "./SummaryBox.css"
export default function SummaryBox({dates, title}) {
    return (
        <div className="sum-box">
            <div>
                {title}
            </div>
            <div className='date-wrapper'>
            <div className="ind-box">{dates[1]}</div>
            <div className="ind-box">{dates[0]}</div>
            <div className="ind-box">{dates[2]}</div>
            </div>
        </div>
    )
}